import axios, { AxiosResponse } from 'axios';
import { PromoCodeUsage } from '../@types/promo-code-usage';

const API_URL = 'https://sodastreamapi.azurewebsites.net/promo-codes-usage';

class PromoCodeUsageService {

  async checkPromoCodeUsage(userId: number, promo_code_id: number): Promise<{ data: PromoCodeUsage | null; error: string | null }> {
    try {
        const response: AxiosResponse<PromoCodeUsage> = await axios.get(`${API_URL}/check`, {
            params: { user_id: userId, promo_code_id: promo_code_id }
        });

        if (response.status >= 200 && response.status < 300) {

          console.log("data found yes : ", response)
            return { data: response.data, error: null };

        } else {
            const error = 'Error fetching promo code usage';
            console.error(error);
            return { data: null, error };
        }
    } catch (error: any) {
        console.error('Error fetching promo code usage:', error);
        return { data: null, error: error.message };
    }
}


  async storePromoCodeUsage(userId: number, promoCodeId: number, promoCode: string): Promise<{ data: PromoCodeUsage | null; error: string | null }> {
    try {
      const response: AxiosResponse<PromoCodeUsage> = await axios.post(`${API_URL}/`, {
        userId,
        promoCodeId,
        promoCode
      });

      if (response.status >= 200 && response.status < 300) {
        return { data: response.data, error: null };
      } else {
        const error = 'Error storing promo code usage';
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error('Error storing promo code usage:', error);
      return { data: null, error: error.message };
    }
  }
}

const promoCodeUsageServiceInstance = new PromoCodeUsageService();
export default promoCodeUsageServiceInstance;
